import { useEffect, useState } from "react";
import axiosInstance from "../../api/axiosInstance";
import { useAppSelector, useAppDispatch } from "../../store/hooks";
import UpdatePatientProfile from "./UpdateProfile";
import { XMarkIcon } from "@heroicons/react/24/outline";

export default function DoctorsList() {
  const [doctors, setDoctors] = useState([]);
  const [search, setSearch] = useState("");
  const [sortKey, setSortKey] = useState("name");
  const [loadingProfile, setLoadingProfile] = useState(true);


  const [showPopup, setShowPopup] = useState(false);
  const user = useAppSelector((s) => s.auth.user);
  const roles = user?.roles || [];
  const isDoctor = roles.includes("doctor");
  const isAdmin = roles.includes("admin");

  useEffect(() => {
    setLoadingProfile(true);
    const fetchProfile = async () => {
      try {
        const res = await axiosInstance.get("/profile/patient");
        const data = res.data?.data;

        if (!data?.name) {
          setShowPopup(true);
        }
      } catch (err) {
        console.error("Failed to fetch patient profile", err);
      } finally {
        setLoadingProfile(false);
      }
    };

    const fetchDoctors = async () => {
      try {
        const res = await axiosInstance.get("/appointment/doctors-list");
        const data = res.data;
        setDoctors(data);
      } catch (err) {
        console.error("Failed to fetch doctors list", err);
      }
    };

    fetchProfile();
    fetchDoctors();
  }, []);

  const filtered = doctors
    .filter((d: any) =>
      d.name.toLowerCase().includes(search.toLowerCase()) ||
      d.specialisation.toLowerCase().includes(search.toLowerCase())
    )
    .sort((a: any, b: any) => a[sortKey].localeCompare(b[sortKey]));

  return (
    <div className="p-6 min-h-screen bg-gray-100">
      <h1 className="text-3xl font-bold mb-4 text-indigo-700">
        Book Doctor Appointment
      </h1>

      {showPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="absolute">
            <UpdatePatientProfile />
            <button
              onClick={() => setShowPopup(false)}
              className="absolute top-0 right-0 hover:text-gray-800 p-2"
            >
              <XMarkIcon className="h-6 w-6" />
            </button>
          </div>
        </div>
      )}

      {/* Table */}
      <div className="bg-white rounded-lg shadow overflow-x-auto">
        <table className="w-full">
          <thead className="bg-indigo-600 text-white">
            <tr>
              <th className="p-3 text-left">Profile</th>
              <th className="p-3 text-left">Doctor Name</th>
              <th className="p-3 text-left">Specialisation</th>
              <th className="p-3 text-left">Treatments</th>
              <th className="p-3 text-left">Action</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((doc: any) => (
              <tr key={doc.doctorId} className="border-b">
                <td className="p-3">
                  <img
                    src={doc.profile}
                    alt={doc.name}
                    className="w-12 h-12 rounded-full object-cover"
                  />
                </td>
                <td className="p-3 font-semibold">{doc.name}</td>
                <td className="p-3">{doc.specialisation}</td>
                <td className="p-3">
                  {doc.treatments?.map(t => t.name).join(", ")}
                </td>
                <td className="p-3">
                  <a
                    href={`/book-doctor/${doc.doctorId}`}
                    className="px-4 py-2 text-white bg-green-600 rounded-lg hover:bg-green-700"
                  >
                    Book Clinic Visit
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
